import React, { cloneElement, type FC } from 'react'
import useGetQuizData from '../hooks/useGetQuizData'
import useGetSession from '../hooks/useGetSession'

const QuizControllerLoader: FC<any> = ({ children }) => {
  const quizId = new URLSearchParams(window.location.search).get('id')
  const review = new URLSearchParams(window.location.search).get('review')

  const quizData = useGetQuizData(quizId)
  const { session } = useGetSession(review)
  if (quizData === undefined || quizId === null || session === undefined) return <div className='animate-skeleton w-full h-full'></div>
  return cloneElement(children, { quizId, quizData, session })
}

export default QuizControllerLoader
